export default function () {
  const widgetName = 'eventFeed';
  const widgetOpts = eventFeedOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(window).load(function () {
        var eventFeedTop = $('#eventFeed').offset().top + ($('#eventFeed').innerHeight() / 3.5);
        var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();

        // function animateeventFeed(val1, val2) {
        //   if (val2 > val1) {
        //     $('#eventFeed').addClass('in-view');
        //   }
        // }

        // if (!$('#eventFeed').hasClass('in-view')) {
        //   animateeventFeed(eventFeedTop, bottomOfScreen);
        // }

        // $(window).on('scroll', function() {
        //   if (!$('#eventFeed').hasClass('in-view')) {
        //     var eventFeedTop = $('#eventFeed').offset().top + ($('#eventFeed').innerHeight() / 3.5);
        //     var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
        //     animateeventFeed(eventFeedTop, bottomOfScreen);
        //   }
        // });

      });

      $('#eventFeed .card-widget-item').each(function (i, item) {
        var imageContainer = $(this).find('.image-container');
        var buttonwrap = $(this).find('.buttonwrap');

        buttonwrap.appendTo(imageContainer);

        var title = $(this).find('.card-widget-title');
        var titleText = title.text();
        var characterLimit = 50;

        if (titleText.length > characterLimit) {
          var trimmedText = titleText.substring(0, characterLimit) + '...';
          title.text(trimmedText);
        }

        var dateText = data.items[i].DetailLinkText;
        var cardContent = $(this).find('.card-content');

        if (dateText === 'More') {
          dateText = data.items[i].DateRange;
        }

        $('<span class="card-widget-date">' + dateText + '</span>').prependTo(cardContent);

        var trimmedDate = $(this).find('.card-widget-date');
        var dateYear = trimmedDate.text().slice(-4);
        var dateMonth = trimmedDate.text().slice(0, 3);
        var dateDay = trimmedDate.text().slice(4, 7).replace(',', '');
        trimmedDate.text(dateMonth + ' ' + dateDay);
        trimmedDate.append('<span>' + dateYear + '</span>');
      });
      $('#eventFeed').attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "250"
      })
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['title'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: false
  });

}